/* Accessible behavior for product details and the measurement drawer. */
if (!customElements.get('elia-product-story')) customElements.define('elia-product-story', class extends HTMLElement {
  connectedCallback() {
    if (this.media) return;
    this.media = matchMedia('(min-width: 990px)');
    this.mobileOpen = new WeakMap();
    this.sync = () => this.querySelectorAll('.elia-detail-core').forEach(d => {
      if (this.media.matches) {
        if (!d.hasAttribute('data-desktop-open')) this.mobileOpen.set(d, d.open);
        d.open = true; d.setAttribute('data-desktop-open', '');
        d.querySelector('summary').tabIndex = -1;
      } else {
        if (d.hasAttribute('data-desktop-open')) d.open = this.mobileOpen.get(d) || false;
        d.removeAttribute('data-desktop-open'); d.querySelector('summary').removeAttribute('tabindex');
      }
    });
    this.clickHandler = e => { if (this.media.matches && e.target.closest('.elia-detail-core>summary')) e.preventDefault(); };
    this.addEventListener('click', this.clickHandler); this.media.addEventListener?.('change', this.sync); this.sync();
  }
  disconnectedCallback() { this.media?.removeEventListener?.('change', this.sync); this.removeEventListener('click', this.clickHandler); this.media=null; }
});
if (!customElements.get('elia-size-guide')) customElements.define('elia-size-guide', class extends HTMLElement {
  connectedCallback() {
    if(this.bound)return;this.bound=true;
    const dialog=this.querySelector('dialog'),open=this.querySelector('[data-guide-open]'),close=this.querySelector('[data-guide-close]');
    open.addEventListener('click',()=>{this.previousOverflow=document.body.style.overflow;dialog.showModal();document.body.style.overflow='hidden';open.setAttribute('aria-expanded','true');close.focus()});
    close.addEventListener('click',()=>dialog.close());
    dialog.addEventListener('close',()=>{document.body.style.overflow=this.previousOverflow||'';open.setAttribute('aria-expanded','false');open.focus()});
    dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close()}});
  }
  disconnectedCallback(){if(this.querySelector('dialog')?.open)document.body.style.overflow=this.previousOverflow||''}
});
if (!customElements.get('elia-model-caption')) customElements.define('elia-model-caption', class extends HTMLElement {
  connectedCallback(){if(this.closest('.product__media-item'))return;const media=this.parentElement.querySelectorAll('.product__media-item');(media[Number(this.dataset.index||2)-1]||media[0])?.append(this);}
});

/* Move the original heading nodes, preserving live prices, IDs and review links. */
if (!customElements.get('elia-pdp-heading-switch')) customElements.define('elia-pdp-heading-switch', class extends HTMLElement {
  connectedCallback() {
    if (this.media) return;
    const info = this.closest('.pdp-info,.product__info-container');
    const layout = this.closest('.pdp-layout,.product');
    const gallery = layout?.querySelector('.pdp-media,.product__media-wrapper');
    if (!info || !gallery) return;
    this.heading = document.createElement('div');
    this.heading.className = 'elia-mobile-product-heading';
    this.heading.hidden = true;
    gallery.before(this.heading);
    this.items = [...info.children].filter(n => n.matches('#pdp-title,.product__title,.elia-price-reviews,.product__tax')).map(node => {
      const anchor = document.createComment('product heading position');
      node.before(anchor);
      return {node, anchor};
    });
    this.media = matchMedia('(min-width: 990px)');
    this.sync = () => {
      const desktop = this.media.matches;
      for (const {node, anchor} of this.items) {
        if (desktop) anchor.after(node);
        else this.heading.append(node);
      }
      this.heading.hidden = desktop;
    };
    this.media.addEventListener?.('change', this.sync);
    this.sync();
  }
  disconnectedCallback() {
    this.media?.removeEventListener?.('change', this.sync);
    for (const {node, anchor} of this.items || []) {anchor.after(node);anchor.remove();}
    this.heading?.remove();
    this.media = null;
  }
});
